import { Skeleton } from "antd";
import PageHeading from "components/PageHeading.component";
import BusinessProfileCard from "components/profile/BusinessProfile.component";
import { useAuth } from "context/AuthContextProvider";
import { getBusinessById } from "hooks/queries/business";
import { translate } from "shared/languages";

// Fetched fresh (React Query), not read from state.business — that's only a
// snapshot taken at login and written to localStorage, never refreshed
// during an active session. A System Admin's edit to this business (name,
// legal_name, etc.) wouldn't show up here until the Manager/Admin logged
// out and back in. state.business.id is still used to know WHICH business
// to fetch — that part of the session snapshot never changes underneath a
// single session.
const BusinessProfilePage = () => {
  const { state } = useAuth();
  const { data: business } = getBusinessById(state.business?.id);
  return (
    <>
      <PageHeading title={translate("business")} />
      {business ? <BusinessProfileCard business={business} /> : <Skeleton active />}
    </>
  );
};
export default BusinessProfilePage;
